const History = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M13 3a9 9 0 1 0 9 9h-2a7 7 0 1 1-7-7v2l4-3-4-3v2Z"
    />
    <path
      fill="currentColor"
      d="M12 8v5l4 2 .8-1.8-3.2-1.4V8h-1.6Z"
    />
  </svg>
)

export default History
